import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getDiscountsAndInvoicesHeader = async (data) => {


    const url = `${ baseUrl }/invoice-monitoring/header`;

    const token = await authHeader();

    return axios
      .get(url, {
        params: data,
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
};

const getDiscountsAndInvoicesDetail = async (data) => {


  const url = `${ baseUrl }/invoice-monitoring/detail`;

  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    }
    )
    .then(response => {
      return response.data;
     }
     )
};
const downloadDiscountsAndInvoicesDetailOrigin  = async (data) =>{
  const url = `${ baseUrl }/invoice-monitoring/excel/origin`
  const token = await authHeader();
  return axios.post(url,data, {
    headers:token
  }).then((response) => {
    return response.data
  })
}

const downloadDiscountsAndInvoiceDetailXlsx = async(data) =>{
  const url = `${baseUrl}/invoice-monitoring/excel/application`
  const token = await authHeader();

  return axios.post(url,data, {
    headers:token,
  }).then((response)=>{
    return response.data
  })
}
const getDiscountsAndInvoicesDetailOrigin = async (data) => {


  const url = `${ baseUrl }/invoice-monitoring/detail-origin`;

  const token = await authHeader();

  return axios
    .get(url, {
      params: data,
      headers: token 
    }
    )
    .then(response => {
      return response.data;
     }
     )
};

const downloaddatDiscountsandInvoiceHeaderXlsx = async(discountInvoiceData, an8, totalData) =>{
  const url = `${baseUrl}/invoice-monitoring/excel/header/${an8}/${totalData.amountAwardedSum}/${totalData.ton}/${totalData.amountAwarded}`;
  const token = await authHeader()
  return axios.
    post(url, discountInvoiceData, {
      headers: token,
    'Content-Type': 'application/json'
    },{
      responseType: "blob"
    }).then((response) =>{
      return response.data
    })
}
export default{
    getDiscountsAndInvoicesHeader,
    getDiscountsAndInvoicesDetail,
    getDiscountsAndInvoicesDetailOrigin,
    downloaddatDiscountsandInvoiceHeaderXlsx,
    downloadDiscountsAndInvoicesDetailOrigin,
    downloadDiscountsAndInvoiceDetailXlsx
  }